// extracted by mini-css-extract-plugin
export default {"root":"ArrivalAndDepartureSection_root__A+4ts","tag":"ArrivalAndDepartureSection_tag__5U8Oy","conditions":"ArrivalAndDepartureSection_conditions__atgqh"};